import {Table} from '@/web-components';
import React from 'react';
import {Tooltip} from '@forecast-it/design-system';
import {TooltipFormulaRenderer} from '../../TooltipFormulaRenderer';
import Util from '../../../forecast-app/shared/util/util';
import {useIntl} from 'react-intl';

export const PercentageColumn = ({value, tooltip, showGenericWinProbabilityTooltip}) => {
	let valuePostfix = '';
	if (showGenericWinProbabilityTooltip) {
		valuePostfix = '*';
	}

	const isPercentage = !!value && !isNaN(value);

	const intl = useIntl();
	const content = (isPercentage ? Util.getFormattedPercentage(value, intl) : '-') + valuePostfix;

	return (
		<Table.Column align={'right'} usePadding negative={value < 0}>
			{tooltip ? (
				<Tooltip content={<TooltipFormulaRenderer items={tooltip} />} interactable={false}>
					{content}
				</Tooltip>
			) : (
				content
			)}
		</Table.Column>
	);
};
